import { useEffect, useRef, useState } from 'react';
import { Box, Link, Typography } from "@mui/material";
import { styled, useTheme } from '@mui/material/styles';
import { Ico_Close, Ico_FolderHeader, Ico_Tasks } from "@sagecentral/core-ui";
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { ProjectHeaderLink } from "components/projects";
import TaskBreadcrumbs from "./TaskBreadcrumb";
import { useTaskContext } from "hooks/tasks";
import { useLocation, useNavigate } from 'react-router-dom';

const HeaderLinkStyled = styled(Link)({
    paddingLeft: '10px'
});

type TaskHeaderProps = {

};

const TaskHeader: React.FC<TaskHeaderProps> = (props) => {
    const taskContext = useTaskContext();
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();    
    const backCount = useRef(0);

    useEffect(() => { 
        if(location.state == null){
            backCount.current = backCount.current - 1;
        }        
      }, [location]);     

    const handleGoBack = () => {
        const previousPath = sessionStorage.getItem('previousURL');
        if (previousPath && (previousPath.includes("signin") || previousPath.includes("login"))) {
            navigate('/tasks/my/in-progress');
        } else {            
            navigate(backCount.current);
        }
    };

    return (
        <>
            {(taskContext.task !== null) ?
                <Box>
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{display: 'flex'}}>
                            Task:&nbsp; <Typography sx={{fontSize: '16px', fontWeight: 600}}>{taskContext.task.name}</Typography>
                        </Box>
                        
                        <Grid xs={1} mdOffset="auto">
                            <Link sx={{ float: 'right' }} onClick={handleGoBack}>
                                <Ico_Close color='primary'/>
                            </Link>
                        </Grid>
                    </Box>
                    <TaskBreadcrumbs task={taskContext.task} />
                </Box>
                : <Box>Task not found</Box>
            }
        </>
    );
}

export default TaskHeader;